/* @ngInject */
const axletreeAsk = (
  utils,
  axletreeLabels,
  axletreeRequest,
  toaster,
  valueHandler,
  saleData
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(axletreeLabels.ask.delete)) {
      try {
        const message = axletreeRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(saleData.mySales.steriles, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  return self
}
export default axletreeAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/ask.service.js